import React, { FC, useMemo } from 'react';
import NotificationActionWrapper from '../NotificationActionWrapper';
import { Button } from 'antd';
import ManageAllNotificationPreference from '../ManageAllNotificationPreference';

interface WorkOrderNotificationActionCardProps {
	workOrderId: number;
	saving: boolean;
	isSubscribeAction?: boolean;
	onConfirm: () => void;
	onCancel: () => void;
}

const WorkOrderNotificationActionCard: FC<WorkOrderNotificationActionCardProps> = ({
	workOrderId,
	saving,
	onConfirm,
	onCancel,
	isSubscribeAction = false,
}): React.ReactElement => {
	const actionText = useMemo(
		() => (isSubscribeAction ? 'Subscribe To:' : 'Unsubscribe from:'),
		[isSubscribeAction]
	);

	return (
		<NotificationActionWrapper>
			<div className="h5medium">{actionText}</div>
			<div className="h2medium">{`WO #${workOrderId}`}</div>
			<div className="flex w-full flex-col justify-center gap-4 px-4">
				<Button type="primary" size="large" loading={saving} onClick={onConfirm}>
					Confirm
				</Button>
				<Button type="primary" ghost size="large" onClick={onCancel}>
					Cancel
				</Button>
			</div>
			<ManageAllNotificationPreference />
		</NotificationActionWrapper>
	);
};

export default WorkOrderNotificationActionCard;
